import { RampInstantSDK } from '@ramp-network/ramp-instant-sdk';
import useTomoUserInfo from './useTomoUserInfo';
import { TokenInfo } from './useOnRamp';

const useOTC = () => {
  const { evmAddress } = useTomoUserInfo();

  const showRamp = (token: TokenInfo) => {
    const symbol = token.ramp_support
      ? token.ramp_support
      : `BSC_${token.symbol}`;

    const hostApiKey = 'zv6q5pv56u6tebstsrbcnbtxeb7twpz84jdxncwx';

    const hostAppName = 'tomo';
    const hostLogoUrl = 'https://pub.tomo.inc/TomoLogo.png';
    const swapAsset = symbol;

    const RampModal = new RampInstantSDK({
      containerNode: document.getElementById('root') as HTMLDivElement,
      hostApiKey,
      hostAppName, // app name
      hostLogoUrl,
      userAddress: evmAddress,
      swapAsset: swapAsset,
      // defaultAsset: symbol,
      // enabledFlows: enabledFlows,
      variant: 'auto',
      // swapAmount: '150000000000000000000', // 150 ETH in wei
    });

    RampModal.on('*', event => console.log('RampModal event', event));
    RampModal.show();
  };

  return {
    showRamp,
  };
};

export default useOTC;
